<template>
    <div class="search-container">
        <transition name="input-expand">
            <el-row>
                <el-col :xs="4" :sm="4" :md="4" :lg="4">
                    <img :src="icoUrl" style="height: 25px; width: 25px;margin-top: 10px;" />
                </el-col>
                <el-col :xs="19" :sm="19" :md="19" :lg="19">
                    <el-input
                        v-model="searchQuery"
                        placeholder="请输入分类名称"
                        clearable
                        class="baidu-style-input"
                        @input="changeInput">
                    </el-input>
                </el-col>
            </el-row>
        </transition>
    </div>
</template>
<script>
export default {
    props: ['searchQuery'],
    data() {
        return {
            groupClassifies: [],
            inputWidth: '200px', // 初始宽度
            expandedWidth: '300px', // 扩展后的宽度
            collapsedWidth: '200px', // 收缩后的宽度
            inputLeft: '0', // 初始 left 值
            expandedLeft: '-100px', // 扩展后的 left 值
            collapsedLeft: '0', // 收缩后的 left 值
        }
    },
    methods: {
        changeInput(val) {
            this.$emit("changeInput", val);
        }
    }
}

</script>

<style lang="css">

.search-container {
    max-width: 600px; /* 可根据需要调整容器的最大宽度 */
}

.baidu-style-input {
    margin-left: 5px;
}

.baidu-style-input .el-input__inner {
    height: 40px; /* 输入框高度 */
    padding: 0 15px; /* 左右内边距 */
    border-radius: 20px; /* 圆角 */
    border: 1px solid #dcdfe6; /* 边框 */
    font-size: 14px; /* 字体大小 */
    transition: border-color 0.2s ease; /* 过渡效果 */
}

/* 鼠标悬停时的样式 */
.baidu-style-input .el-input__inner:hover {
    border-color: #c0c4cc; /* 边框颜色变化 */
}

/* 输入框聚焦时的样式 */
.baidu-style-input .el-input__inner:focus {
    border-color: #409eff; /* 聚焦时的边框颜色 */
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2); /* 聚焦时的阴影效果 */
}

/* 搜索按钮样式 */
.baidu-style-input .el-input__suffix .el-button {
    border-top-left-radius: 0; /* 按钮左边圆角清除 */
    border-bottom-left-radius: 0;
    margin-left: -1px; /* 修正按钮位置 */
}
</style>


// WEBPACK FOOTER //
// src/views/classify/classifySearch.vue